import React, { useState } from 'react';
import { Select, SelectProps } from 'antd';
import { CaretDownFilled } from '@ant-design/icons';
import styles from './TemplateOptionsRfxGenerator.module.scss';

const { Option } = Select;

interface TemplateOptionsProps {
  options: Array<{
    id: string;
    rfx_template_name: string;
    intake_form_template_name: string;
    intake_form_gcs_loc: string;
  }>;
  onChange?: (value: string, template: any) => void;
  selectedValue: string;
  disabled: boolean;
}

const TemplateOptionsRfxGenerator: React.FC<TemplateOptionsProps> = ({ options = [], onChange, selectedValue, disabled }) => {

  const handleChange = (value: string) => {
    const rfxGeneratorSelectedTemplate = options?.find(option => option.id === value);
    if (onChange && rfxGeneratorSelectedTemplate) {
      onChange(value, rfxGeneratorSelectedTemplate);
    }
  };

  const filterOption: SelectProps['filterOption'] = (input, option) => {
    return option?.children
      ? String(option.children).toLowerCase().includes(input.toLowerCase())
      : false;
  };

  return (
    <div className={styles.templateOptionsContainer}>
      <Select
        showSearch
        className={styles.customSelect}
        placeholder="Search Template"
        value={selectedValue}
        onChange={handleChange}
        optionFilterProp="children"
        filterOption={filterOption}
        dropdownClassName={styles.customDropdown}
        suffixIcon={<CaretDownFilled style={{ color: '#1D1B20' }} />}
        disabled={disabled}
      >
        {options?.map((option) => (
          <Option key={option.id} value={option.id}>
            {option.rfx_template_name}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default TemplateOptionsRfxGenerator;
